import cleanCoords from '@turf/clean-coords';

export const mergeFeatureGeometries = features => {
  const groupedRings = features.map(feature => {
    const geom = feature.geometry;
    if (geom.type === 'Polygon') {
      return [geom.coordinates];
    } else {
      return geom.coordinates;
    }
  });

  let flatRings = [];
  groupedRings.forEach(group => {
    flatRings = flatRings.concat(group);
  });

  return {
    type: 'MultiPolygon',
    coordinates: flatRings,
  };
};

export const reducePrecision = (geometry, precision = 8) => {
  // This is an expensive operation in javascript, memo it here.
  const power = Math.pow(10, precision);
  // This helped the JIT compile this fucntion ahead of time.
  const reduce = n => Math.trunc(n * power) / power;
  const reduceRing = ring => ring.map(pt => [reduce(pt[0]), reduce(pt[1])]);
  const reducePolygon = rings => rings.map(reduceRing);
  if (geometry.type === 'Polygon') {
    return {
      type: 'Polygon',
      coordinates: reducePolygon(geometry.coordinates),
    };
  }
  // Assume multipolygon
  return {
    type: 'MultiPolygon',
    coordinates: geometry.coordinates.map(polygon => reducePolygon(polygon)),
  };
};

export const dedupePoints = (complexGeometry, precision = 8) => {
  // After the points are of reduced precision,
  //  they can occasionally overlap.
  // This removes the duplicate points if they exist.
  const geometry = reducePrecision(complexGeometry, precision);

  return cleanCoords(geometry);
};

const countPolygonPoints = rings =>
  rings.map(ring => ring.length).reduce((total, count) => total + count, 0);

export const countVertexes = geometry => {
  let polygons = [];
  if (geometry.type === 'Polygon') {
    polygons = [geometry.coordinates];
  } else {
    // MultiPolygon
    polygons = geometry.coordinates;
  }
  return polygons
    .map(polygon => countPolygonPoints(polygon))
    .reduce((total, count) => total + count, 0);
};
